export class Util {
  static formatAsCurrency(amount: number): string {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return formatter.format(amount);
  }

  static openURL(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }

  static validateEmail(email: string): boolean {
    // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  static validateEmailNotRequired(email: string): boolean {
    if (!email || email.length===0) {
      return true;
    }
    // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  static validatePhone(phone: string): boolean {
    // https://stackoverflow.com/questions/4338267/validate-phone-number-with-javascript
    const re = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g;
    return re.test(phone);
  }

  static validatePhoneNotRequired(phone: string): boolean {
    // https://stackoverflow.com/questions/4338267/validate-phone-number-with-javascript
    if (!phone || phone.length==0) {
      return true;
    }
    const re = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g;
    return re.test(phone);
  }

  static sanitizeEmail(email: string): string {
    return email.toLowerCase().trim();
  }

  static sanitizePhone(phone: string): string {
    const trimmed = phone.trim();
    let trimmedWithCountryCode;
    if (trimmed.length === 10) {
      // for now, assume north america if country code is not specified
      trimmedWithCountryCode = '1' + trimmed;
    } else if (trimmed.length === 11 || trimmed.length === 12) {
      trimmedWithCountryCode = trimmed;
    }
    return '+' + trimmedWithCountryCode;
  }

  static encode(data: any) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
  }
}
